import React from 'react'
// import PropTypes from 'prop-types'
import Container from 'react-bootstrap/Container'
import { BrowserRouter as Router, Route } from 'react-router-dom'

// Components -------
import Header from './components/Header'
import Footer from './components/Footer'

// Screens -------
import HomeScreen from './screens/HomeScreen'
import ProductScreen from './screens/ProductScreen'
import CartScreen from './screens/CartScreen'
import LoginScreen from './screens/LoginScreen'
import RegisterScreen from './screens/RegisterScreen'
import ProfileScreen from './screens/ProfileScreen'
import ShippingScreen from './screens/ShippingScreen'
import PaymentScreen from './screens/PaymentScreen'
import PlaceOrderScreen from './screens/PlaceOrderScreen'
import OrderScreen from './screens/OrderScreen'
import OrderListScreen from './screens/OrderListScreen'
import UserListScreen from './screens/UserListScreen'
import UserEditScreen from './screens/UserEditScreen'
import ProductListScreen from './screens/ProductListScreen'
import ProductEditScreen from './screens/ProductEditScreen'

const App = props => {
	return (
		<Router>
			<Header />

			<main className="py-3">
				<Container>
					<Route path="/admin/orderlist" component={OrderListScreen} />
					<Route path="/admin/product/:id/edit" component={ProductEditScreen} />
					<Route
						path="/admin/productlist/:pageNumber"
						component={ProductListScreen}
						exact
					/>
					<Route
						path="/admin/productlist"
						component={ProductListScreen}
						exact
					/>
					<Route path="/admin/user/:id/edit" component={UserEditScreen} />
					<Route path="/admin/userlist" component={UserListScreen} />
					<Route path="/order/:id" component={OrderScreen} />
					<Route path="/placeorder" component={PlaceOrderScreen} />
					<Route path="/payment" component={PaymentScreen} />
					<Route path="/shipping" component={ShippingScreen} />
					<Route path="/profile" component={ProfileScreen} />
					<Route path="/login" component={LoginScreen} />
					<Route path="/register" component={RegisterScreen} />
					<Route path="/product/:id" component={ProductScreen} />
					<Route path="/cart/:id?" component={CartScreen} />
					<Route path="/search/:keyword" component={HomeScreen} exact />
					<Route path="/page/:pageNumber" component={HomeScreen} exact />
					<Route
						path="/search/:keyword/page/:pageNumber"
						component={HomeScreen}
						exact
					/>
					<Route path="/" exact component={HomeScreen} />
				</Container>
			</main>

			<Footer />
		</Router>
	)
}

App.propTypes = {
	//
}

export default App
